import produce from "immer";
import React from "react";
import { useForm, OnSubmit } from "react-hook-form";
import InputForm from "src/components/atoms/FormInputs/InputForm";
import { SubmitFormButton } from "src/components/atoms/inputs/EwaButtons";
import { ButtonType, FlowioInputType } from "src/globalTypes";
import { useFormatMsg } from "src/hooks/useFormatMsg";
import { LangCode } from "src/requests/localization/types";
import { useLocalizationString } from "src/store/localization/useSelectors";
import NoFooterModal from "../NoFooterModal";
import { Container } from "./styles";
import { OnChangeTranslations, Translations } from "./types";

type Props = {
  isOpen: boolean;
  translations: Translations;
  toggle(): void;
  onSave: OnChangeTranslations;
};

const TranslationsModal = ({ isOpen, translations, toggle, onSave }: Props) => {
  const formatMsg = useFormatMsg();
  const localeLang = useLocalizationString();

  const { register, getValues } = useForm<Translations>({
    defaultValues: translations,
  });

  const onSubmitHandle = () => {
    const data = getValues();
    const updatedTranslations = produce(translations, (draft) => {
      Object.entries(data).forEach(([key, value]) => {
        draft[key as LangCode] = value;
      });
    });
    onSave(updatedTranslations);
    toggle();
  };

  return (
    <NoFooterModal
      isOpen={isOpen}
      toggle={toggle}
      title={formatMsg("common.translation")}
    >
      <Container>
        {localeLang === LangCode.English && (
          <InputForm
            name={LangCode.Czech}
            label={formatMsg("localization.cs")}
            type={FlowioInputType.Text}
            inputRef={register}
          />
        )}
        {localeLang === LangCode.Czech && (
          <InputForm
            name={LangCode.English}
            label={formatMsg("localization.en")}
            type={FlowioInputType.Text}
            inputRef={register}
          />
        )}
        <SubmitFormButton
          label={formatMsg("common.save")}
          onClick={onSubmitHandle}
          type={ButtonType.Button}
        />
      </Container>
    </NoFooterModal>
  );
};

export default TranslationsModal;
